export const GET_ALL_VENUES= 'GET_ALL_VENUES'
export const GET_ALL_VENUES_SUCCESS= 'GET_ALL_VENUES_SUCCESS'
export const GET_ALL_VENUES_ERROR='GET_ALL_VENUES_ERROR'

export const GetAllVenues= (data) => ({
    type: GET_ALL_VENUES,
    payload: data
})


